import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { settingUpdate } from "../../api/Setting";
import { BankList } from "../../api/BankService";
import { imgBaseUrl } from "../../api/api";
import SettingLayout from "./SettingLayout";

export default function AdditionDetails() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [banks, setBanks] = useState([]);

  const parseArray = (value) => {
    if (!value) return []; // null, undefined, ""

    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }

    return [];
  };

  useEffect(() => {
    const setting = JSON.parse(localStorage.getItem("setting") || "{}");

    setData({
      ...setting,
      rte_in_free: parseArray(setting.rte_in_free),
      student_fee_fixed: parseArray(setting.student_fee_fixed),
      staff_details: parseArray(setting.staff_details),
    });
    getBankList();
  }, []);

  const handleUpdateData = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      formData.set("staff_details", JSON.stringify(data.staff_details ?? []));
      const response = await settingUpdate(formData);
      if (response.data.status === true) {
        localStorage.setItem("setting", JSON.stringify(response.data.data));
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBankList = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response.data.status === true) {
        setBanks(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const is_checked = (name, value) => {
    return parseArray(data?.[name]).includes(value);
  };

  const checked_update = (name, e) => {
    const value = e.target.value;
    const currentArray = parseArray(data?.[name]);

    const updated = e.target.checked
      ? [...new Set([...currentArray, value])]
      : currentArray.filter((item) => item !== value);

    setData((prev) => ({
      ...prev,
      [name]: updated,
    }));
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <SettingLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form className="row g-4" onSubmit={handleUpdateData}>
                          <div className="col-12">
                            <h5 className="text-primary m-0">
                              Headers Logo Details
                            </h5>
                          </div>
                          <div className="col-12">
                            <div className="row">
                              {[
                                "enquiry_header_logo",
                                "enquiry_demo_header_logo",
                                "student_admission_header_logo",
                              ]?.map((logo, i) => (
                                <>
                                  <div className="col-3 mb-3">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="file"
                                        className="form-control"
                                        name={logo}
                                        placeholder={logo?.toUpperCase()}
                                      />

                                      <label>{logo?.toUpperCase()}</label>
                                    </div>
                                  </div>
                                  <div className="col-3 mb-3">
                                    <img
                                      src={imgBaseUrl + data?.[logo]}
                                      className="w-100"
                                      alt=""
                                    />
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                          <div className="col-12">
                            <hr />
                            <h5 className="text-primary m-0">
                              Addition Details
                            </h5>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="default_bank_id"
                                id="default_bank_id"
                                className="form-select"
                                value={data?.default_bank_id || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    default_bank_id: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Default Bank
                                </option>
                                {banks?.map((bank, i) => (
                                  <option key={i} value={bank?.id}>
                                    {bank?.account_no} ({bank?.owner_name})
                                  </option>
                                ))}
                              </select>

                              <label htmlFor="default_bank_id">
                                Default Bank
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="transport_status"
                                id="transport_status"
                                className="form-select"
                                value={data?.transport_status || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    transport_status: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Transport Status
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="transport_status">
                                Transport Status
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="rte_status"
                                id="rte_status"
                                className="form-select"
                                value={data?.rte_status || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    rte_status: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select RTE Status
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="rte_status">RTE Status</label>
                            </div>
                          </div>
                          {data?.rte_status === "Yes" && (
                            <div className="col-md-12">
                              <p>RTE In Free</p>
                              <div className="row">
                                {[
                                  "registration_fee",
                                  "tuition_fee",
                                  "exam_fee",
                                  "bus_fee",
                                ]?.map((fee, i) => {
                                  if (
                                    data?.transport_status !== "Yes" &&
                                    fee === "bus_fee"
                                  ) {
                                    return "";
                                  }
                                  return (
                                    <div className="col" key={i}>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={fee}
                                          name="rte_in_free[]"
                                          id={fee}
                                          checked={is_checked(
                                            "rte_in_free",
                                            fee,
                                          )}
                                          onChange={(e) =>
                                            checked_update("rte_in_free", e)
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={fee}
                                        >
                                          {fee?.toUpperCase()}
                                        </label>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}

                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="message_status"
                                id="message_status"
                                className="form-select"
                                value={data?.message_status || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    message_status: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Message Status
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="message_status">
                                Message Status
                              </label>
                            </div>
                          </div>
                          {data?.message_status === "Yes" && (
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="select_message_type"
                                  id="select_message_type"
                                  className="form-select"
                                  value={data?.select_message_type || ""}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      select_message_type: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" disabled>
                                    Select Message Type
                                  </option>
                                  <option value="Meta">Meta</option>
                                  <option value="Text">Text</option>
                                </select>

                                <label htmlFor="select_message_type">
                                  Message Type
                                </label>
                              </div>
                            </div>
                          )}
                          {data?.message_status === "Yes" &&
                            data?.select_message_type === "Meta" && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="meta_wa_api_token"
                                    name="meta_wa_api_token"
                                    defaultValue={data?.meta_wa_api_token}
                                  />
                                  <label htmlFor="meta_wa_api_token">
                                    Meta Massage API Token
                                  </label>
                                </div>
                              </div>
                            )}


                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="auto_signature"
                                id="auto_signature"
                                className="form-select"
                                value={data?.auto_signature || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    auto_signature: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Auto Signature
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="auto_signature">
                                Auto Signature
                              </label>
                            </div>
                          </div>



                          <div className="col-12">
                            <hr />
                            <h5 className="text-primary mb-0">Fee Details</h5>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="batch_create_time_add_fees"
                                id="batch_create_time_add_fees"
                                className="form-select"
                                value={data?.batch_create_time_add_fees || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    batch_create_time_add_fees: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Batch Create Time Add Fees
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="batch_create_time_add_fees">
                                Batch Create Time Add Fees
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="batch_create_time_limit_student"
                                id="batch_create_time_limit_student"
                                className="form-select"
                                value={
                                  data?.batch_create_time_limit_student || ""
                                }
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    batch_create_time_limit_student:
                                      e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select Batch Create Time Add Limit Student
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="batch_create_time_limit_student">
                                Batch Create Time Add Limit Student
                              </label>
                            </div>
                          </div>

                          {data?.batch_create_time_add_fees === "Yes" && (
                            <div className="col-6">
                              {[
                                "registration_fee",
                                "tuition_fee",
                                "bus_fee",
                                "exam_fee",
                              ]?.map((fee, i) => (
                                <div className="form-check" key={i}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={fee}
                                    name="student_fee_fixed[]"
                                    id={fee}
                                    checked={is_checked(
                                      "student_fee_fixed",
                                      fee,
                                    )}
                                    onChange={(e) =>
                                      checked_update("student_fee_fixed", e)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={fee}
                                  >
                                    Student Add Time {fee?.toUpperCase()} Fixed
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}

                          <div className="col-12">
                            <hr />
                            <h5 className="text-primary mb-0">Staff Details</h5>
                          </div>

                          <div className="col-12">
                            <div className="row">
                              {["salary_details"]?.map((type, i) => {
                                return (
                                  <div className="col" key={i}>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={type}
                                        name="staff_details[]"
                                        id={type}
                                        checked={is_checked(
                                          "staff_details",
                                          type,
                                        )}
                                        onChange={(e) =>
                                          checked_update("staff_details", e)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={type}
                                      >
                                        {type?.toUpperCase()}
                                      </label>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className="col-md-12 text-end">
                            <button type="submit" className="btn btn-primary ">
                              Save changes
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
